import type { ThemeDefinition } from '../registry';

export const EDITORIAL_THEME: ThemeDefinition = {
  themeId: 'editorial',
  name: 'Editorial',
  baseThemeId: 'default',
  palette: {
    background: '#FBFAF7',
    surface: '#F7F0E6',
    text: '#24211D',
    textMuted: '#6E655B',
    primary: '#7A2433',
    primaryContrast: '#FFFFFF',
    secondary: '#27584F',
    secondaryContrast: '#FFFFFF',
    accent: '#D28A2E',
  },
  fonts: {
    headingFont: 'Georgia, serif',
    bodyFont: 'Trebuchet MS, sans-serif',
  },
  layouts: {
    TITLE: {
      background: '$background',
      placeholders: [
        {
          placeholderId: 'TITLE',
          position: { x: 92, y: 164, width: 690, height: 112 },
          textStyle: {
            fontSize: 50,
            lineHeight: 1,
            color: '$text',
          },
        },
        {
          placeholderId: 'SUBTITLE',
          position: { x: 96, y: 312, width: 650, height: 68 },
          textStyle: {
            fontSize: 24,
            color: '$textMuted',
            lineHeight: 1.2,
          },
        },
      ],
      decoration: [
        {
          type: 'shape',
          position: { x: 0, y: 0, width: 42, height: 540, rotation: 0, zIndex: 0 },
          content: { shapeType: 'rectangle', fillColor: '$primary', strokeWidth: 0 },
        },
        {
          type: 'shape',
          position: { x: 760, y: 0, width: 200, height: 540, rotation: 0, zIndex: 0 },
          content: { shapeType: 'rectangle', fillColor: '$surface', strokeWidth: 0 },
        },
        {
          type: 'shape',
          position: { x: 92, y: 292, width: 108, height: 5, rotation: 0, zIndex: 0 },
          content: { shapeType: 'rectangle', fillColor: '$accent', strokeWidth: 0 },
        },
      ],
    },
    TITLE_AND_BODY: {
      placeholders: [
        {
          placeholderId: 'TITLE',
          position: { x: 92, y: 46, width: 738, height: 74 },
          textStyle: { color: '$primary' },
        },
        {
          placeholderId: 'BODY',
          position: { x: 94, y: 154, width: 744, height: 336 },
          textStyle: { color: '$text' },
        },
      ],
      decoration: [
        {
          type: 'shape',
          position: { x: 0, y: 0, width: 960, height: 12, rotation: 0, zIndex: 0 },
          content: { shapeType: 'rectangle', fillColor: '$primary', strokeWidth: 0 },
        },
        {
          type: 'shape',
          position: { x: 92, y: 128, width: 128, height: 4, rotation: 0, zIndex: 0 },
          content: { shapeType: 'rectangle', fillColor: '$accent', strokeWidth: 0 },
        },
        {
          type: 'shape',
          position: { x: 878, y: 84, width: 34, height: 348, rotation: 0, zIndex: 0 },
          content: { shapeType: 'rectangle', fillColor: '$surface', strokeWidth: 0 },
        },
      ],
    },
    TITLE_AND_TWO_COLUMNS: {
      placeholders: [
        {
          placeholderId: 'TITLE',
          position: { x: 92, y: 44, width: 760 },
          textStyle: { color: '$primary' },
        },
        {
          placeholderId: 'LEFT_BODY',
          position: { x: 80, y: 140, width: 392, height: 352 },
          textStyle: { backgroundColor: '$surface', padding: 22 },
        },
        {
          placeholderId: 'RIGHT_BODY',
          position: { x: 500, y: 140, width: 392, height: 352 },
          textStyle: { backgroundColor: '$surface', padding: 22 },
        },
      ],
      decoration: [
        {
          type: 'shape',
          position: { x: 102, y: 122, width: 118, height: 4, rotation: 0, zIndex: 0 },
          content: { shapeType: 'rectangle', fillColor: '$accent' },
        },
      ],
    },
  },
};
